(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputText', cpInputText);

    cpInputText.$inject = [];

    function cpInputText() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-text/input-text.html',
            scope: {
                type: '@',
                title: '@',
                labelClass: '@?',
                containerClass: '@',
                object: '=',
                prop: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?',
                withLabel: '=?',
                minValue: '@?',
                maxValue: '@?',
                minLength: '@?',
                maxLength: '@?',
                precision: '@?',
                unit: '@?',
                onEdit: '&?',
                inputClass: '@?'
            },
            link: function(scope, element, attrs, controller) {
                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;
                scope.isWithLabel = isWithLabel;

                function isWithLabel() {
                    return scope.withLabel === undefined ? true : scope.withLabel;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return isWithLabel() ? 'col-sm-2' : '';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-10' : 'col-sm-12';
                    }
                }
            }
        };
    }
})();
